export default __webpack_public_path__ + "static/media/Excellent-Aesthetics.c29cc0b3.jpg";